/* eslint-disable jsx-a11y/alt-text */
import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import BuyConfirmationModal from "./Buy";
import { addCommercialContract, updateCommercialDB3, updateLotFields } from "../Redux/products/slice";
import { setShowLogin } from "../Redux/user/slice";
import { toast } from "react-toastify";
import { ToastProperties } from '../utils/constants/toastProperties';
import { Carousel } from '@mantine/carousel';
import { ActionIcon, Center, Group, Stack, Text, Textarea, Tooltip } from '@mantine/core';
import { IconPencil, IconCheck, IconX } from '@tabler/icons-react';
import { FormattedMessage, useIntl } from "react-intl";

function ProductPanel({
  toggle,
  modal = false,
  title,
  value,
  buyerID,
  SellerID,
  readonly,
}) {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [buyerConfirmationModal, setBuyerConfirmation] = useState(false);
  const [productImages, setProductImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [editingNotes, setEditingNotes] = useState(false);
  const [editedNotes, setEditedNotes] = useState('');
  const [localNotes, setLocalNotes] = useState(null);
  const { userInfo: userDetails } = useSelector(s => s.user)

  const handleInterested = (v) => {
    const userinfo = JSON.parse(localStorage.getItem('userinfo'))
    if (value.ownerID !== userinfo.userId) {
      const payload = {
        "contractRefId": v.contractRefID,
        "SELLERID": v.ownerID,
        "BUYERID": userinfo.userId,
        "state": "InNegotiation",
        sku: -1,
        productRefId: v.productID,
      }
      dispatch(updateCommercialDB3(payload))

      setTimeout(() => {
        toggle()
      }, 3000)
    } else {
      toast.success("You cannot proceed with this request as you are the owner", {
        ...ToastProperties
      });
    }
  }

  const handleCreateContract = () => {
    const getUser = localStorage.getItem("userLogged");
    const userinfo = JSON.parse(localStorage.getItem('userinfo'))
    console.log({ value, userinfo, getUser })
    if (getUser && userinfo) {
      handleInterested(value)
    } else {
      dispatch(setShowLogin({ value: true, cb: () => handleInterested(value) }))
    }
  };

  useEffect(() => {
    if (value?.productID) {
      loadAllImages(value.productID);
    }
  }, [value]);

  const loadAllImages = async (productID) => {
    const images = [];
    const baseUrl = 'https://vertoledgerstorage.blob.core.windows.net/sqldbledgerdigests/images/';
    
    // Try main image
    const mainImage = `${baseUrl}${productID}.png`;
    if (await checkImageExists(mainImage)) {
      images.push(mainImage);
    }
    
    // Try numbered images (_1, _2, _3, etc.)
    for (let i = 1; i <= 10; i++) {
      const imageUrl = `${baseUrl}${productID}_${i}.png`;
      if (await checkImageExists(imageUrl)) {
        images.push(imageUrl);
      } else {
        break;
      }
    }
    
    // If no images found, use default image based on product_name_id
    if (images.length === 0 && value?.product_name_id) {
      const defaultImage = `${baseUrl}${value.product_name_id}.jpg`;
      images.push(defaultImage);
    }
    
    setProductImages(images);
    setCurrentImageIndex(0);
  };

  const checkImageExists = async (url) => {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      return response.ok;
    } catch (error) {
      return false;
    }
  };

  const updatePayload = () => {
    const userinfo = JSON.parse(localStorage.getItem('userinfo'))

    return {
      productRefId: value.productID,
      contractId: userinfo.commercial_contractId,
      sellerId: value.ownerID,
      buyerId: userinfo.userId,
      contractDetails: "Delivery Santos/Period October 2023/Incoterm FOB/3000 $ per MT /Sample/Arbitration/Validity offer 1 day",
      price: "0",
      location: value.location,
      period: value.period,
      quantity: value.quantity,
      productNotes: value.productNotes
    }
  };

  const handleConfirmOrder = () => {
    dispatch(addCommercialContract(updatePayload()));
  };

  const renderProductNotes = () => {
    const notes = localNotes !== null ? localNotes : value?.productNotes;

    const userinfo = JSON.parse(localStorage.getItem('userinfo'));
    const isOwner = userinfo && (
      (userinfo.userId && value?.ownerID && userinfo.userId === value.ownerID) ||
      (userinfo.email && value?.OwnerID && userinfo.email === value.OwnerID)
    );

    if (editingNotes) {
      return (
        <Grid sx={{ border: '1px solid gray' }} container direction="row">
          <Grid item sx={{ width: '50%' }}>
            <FormattedMessage id="product.notes" />
          </Grid>
          <Grid item sx={{ width: '50%' }}>
            <Stack spacing={4}>
              <Textarea
                value={editedNotes}
                onChange={(e) => setEditedNotes(e.target.value)}
                autosize
                minRows={3}
                maxRows={10}
                styles={{
                  input: { fontFamily: 'inherit', fontSize: '0.875rem' },
                }}
              />
              <Group position="right" spacing={4}>
                <Tooltip label={intl.formatMessage({ id: 'button.cancel' })} withArrow>
                  <ActionIcon variant="light" color="gray" size="sm" onClick={() => setEditingNotes(false)}>
                    <IconX size={14} />
                  </ActionIcon>
                </Tooltip>
                <Tooltip label={intl.formatMessage({ id: 'button.save' })} withArrow>
                  <ActionIcon variant="filled" color="green" size="sm" onClick={handleSaveNotes}>
                    <IconCheck size={14} />
                  </ActionIcon>
                </Tooltip>
              </Group>
            </Stack>
          </Grid>
        </Grid>
      );
    }

    return (
      <Grid sx={{ border: '1px solid gray' }} container direction="row">
        <Grid item sx={{ width: '50%' }}>
          <FormattedMessage id="product.notes" />
        </Grid>
        <Grid item sx={{ width: '50%' }}>
          {notes && typeof notes === 'string' && notes.split('\\r\\n').map((note, index) => {
            const colonIdx = note.indexOf(':');
            if (colonIdx === -1) {
              return note.trim() ? <div key={`note-${index}`}>{note.trim()}</div> : null;
            }
            const label = note.slice(0, colonIdx).trim();
            const noteValue = note.slice(colonIdx + 1).trim();
            if (!label && !noteValue) return null;
            return (
              <div key={`note-${index}`}><strong>{label}:</strong> {noteValue}</div>
            );
          })}
          {isOwner && (
            <Tooltip label={intl.formatMessage({ id: 'product.notes.edit' })} withArrow position="left">
              <ActionIcon
                variant="subtle"
                color="blue"
                size="sm"
                onClick={() => {
                  setEditedNotes((notes || '').replace(/\\r\\n/g, '\n'));
                  setEditingNotes(true);
                }}
              >
                <IconPencil size={14} />
              </ActionIcon>
            </Tooltip>
          )}
        </Grid>
      </Grid>
    );
  };

  const handleSaveNotes = () => {
    const userinfo = JSON.parse(localStorage.getItem('userinfo'));
    const serialized = editedNotes.replace(/\r?\n/g, '\\r\\n');
    dispatch(updateLotFields({
      productId: value?.productID,
      sqlFields: { productNotes: serialized },
    }));
    setLocalNotes(serialized);
    setEditingNotes(false);
  };

  return (
    <Modal isOpen={modal} toggle={toggle} style={{ height: "auto" }}>
      {title && <ModalHeader toggle={toggle}>{"Sale - " + title}</ModalHeader>}
      {!title && <ModalHeader toggle={toggle}>{<FormattedMessage id="modal.sale.title1" />}</ModalHeader>}

      <ModalBody>
        <BuyConfirmationModal
          modal={buyerConfirmationModal}
          toggle={() => {
            setBuyerConfirmation(false);
            toggle();
          }}
          buyerID={"0.0.48903622"}
          SellerID={"0.0.48903965"}
          buyerName={"Test Buyer"}
          sellerName={"Test Seller"}
          value={value}
        />
        <Grid container>
          <Grid item xs={12}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "10px" }}>
              {productImages.length > 1 ? (
                <Carousel 
                  withIndicators 
                  height={300}
                  slideSize="100%"
                  slideGap="md"
                  loop
                  align="start"
                >
                  {productImages.map((img, idx) => (
                    <Carousel.Slide key={idx}>
                      <img 
                        src={img} 
                        alt={intl.formatMessage({ id: 'productPanel.imageAlt' }, { number: idx + 1 })} 
                        style={{ 
                          width: '100%', 
                          height: '100%', 
                          objectFit: 'contain' 
                        }} 
                      />
                    </Carousel.Slide>
                  ))}
                </Carousel>
              ) : productImages.length === 1 ? (
                <img 
                  src={productImages[0]} 
                  alt={intl.formatMessage({ id: 'productPanel.productImage' })} 
                  style={{ 
                    width: '100%', 
                    height: 300, 
                    objectFit: 'contain' 
                  }} 
                />
              ) : (
                <Center style={{ height: 300, backgroundColor: '#f0f0f0', width: '100%' }}>
                  <Text color="dimmed">
                    {intl.formatMessage({ id: 'productPanel.noImages' })}
                  </Text>
                </Center>
              )}
            </div>
          </Grid>
          <Grid item xs={12} sx={{ border: "1px solid gray" }}>
            <Grid container direction={"row"}>
              <Grid item sx={{ width: "100%" }}>
                <Description
                  label={<FormattedMessage id="product.name1" />}
                  value={value?.productName}
                />
                {renderProductNotes()}
                <Description label={<FormattedMessage id="product.quantity1" />} value={value?.quantity} />
                <Description label={<FormattedMessage id="product.owner1" />} value={value?.OwnerID} />
                <Description
                  label={<FormattedMessage id="product.physicalstate1" />}
                  value={value?.physicalState}
                />
                <Description label={<FormattedMessage id="product.physloc1" />} value={value?.location} />
                <Description label={<FormattedMessage id="product.dateon1" />} value={value?.period} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ModalBody>
      {!readonly && (
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            <FormattedMessage id="button.cancel" />
          </Button>
        </ModalFooter>
      )}

      <ModalFooter style={{ display: "flex", justifyContent: "center" }}>
        {!readonly && (
          <>
            <Button color="warning" onClick={handleCreateContract}>
              <FormattedMessage id="button.interested" />
            </Button>
          </>
        )}
      </ModalFooter>
    </Modal>
  );
}

const Description = ({ label, value }) => {
  return (
    <Grid sx={{ border: "1px solid gray" }} container direction={"row"}>
      <Grid item sx={{ width: "50%" }}>
        {label}
      </Grid>
      <Grid item sx={{ width: "50%" }}>
        {value}
      </Grid>
    </Grid>
  );
};

export default ProductPanel;
